export default "È\nO\nDove\nChe cosa\nCome\nquanti\nQuanto\nDovrebbe\nPotere"